export { default as Visualizar } from './VisualizarContainer';